import { createAsyncThunk } from "@reduxjs/toolkit";
import service from "./service";
import { checkForMandatoryFields, checkForWaringErrors, generateQueryString, getChangedProcedure, getReviewedClaims, getSelectedClaimIDs, structureSaveProcedureData } from "./DataProcessor";
import { getStorage } from "../../../../utilities/browserStorage";
import { DEFAULT_PAGING_SIZE } from "../../../../utilities/staticConfigs";
import i18n from "../../../../utilities/i18n";
import { formatDateUS } from "../../../../utilities/commonUtilities";
import { onGridCheckBoxClickEraList } from "./eraSlice";

export const getERApayerList = createAsyncThunk(
    "erapayer/geterapayer",
    async (payload, { rejectWithValue }) => {
        const result = await service.ERAPayer(payload);
        if (result) {
            let data = [];
            if (result.data && result.data.length > 0) {
                result.data.forEach((item) => {
                    data.push({ 'id': item.Id, 'name': item.name })
                })
            }

            return data;
        } else {
            return rejectWithValue("Something went wrong.Please try again")
        }
    }
)


export const getERAlist = createAsyncThunk(
    "erapayer/era_list",
    async (payload, { getState,rejectWithValue }) => {
        let { page, calledFrom, practice } = payload;
        const state = getState();
        let { ERAData } = state;
        let { pageSelector, pagination, eraSearchVariables } = ERAData;
        const query = generateQueryString(page, pageSelector, pagination, calledFrom, eraSearchVariables);
        const result = await service.GetEraListData(practice, query);
        if (result.data) {
            return { tableData: result.data, page: page, calledFrom: calledFrom }
        }else{
            return rejectWithValue("Something went wrong.Please try again")
        }

    }
)

export const getERASummuryData = createAsyncThunk(
    "era/era-summary-data",
    async (payload, { getState, rejectWithValue }) => {
        let { id, isApplied } = payload;
        const state = getState();
        const { ERAData } = state;
        let { eraTableData } = ERAData;
        let item = eraTableData.find(obj => obj.id == id);
        const era_adj_result = await service.EraAdjustmentType(id);
        const header_result = await service.GetHeader(id);
        if (header_result.data) {
            let qry = 'header_details_pk=' + id
            const result = await service.GetClaimDataSummary(qry)
            if (result.data) {
                return {
                    eraData: era_adj_result.data,
                    header_result: header_result.data,
                    summaryData: result.data,
                    id: id,
                    isApplied: isApplied == true ? 2 : item?.applied_status,
                }
            } else {
                return rejectWithValue("Something went wrong please try again")
            }
        } else {
            return rejectWithValue("Something went wrong please try again")
        }
    }
)

export const reviewClaimData = createAsyncThunk(
    "era/era-review_claim",
    async (payload, { getState,rejectWithValue }) => {
        let { claim_pk, newClaimAdded, is_applied,ele } = payload;
        const currentState = getState();
        let { ERAData } = currentState;
        let { isApplied, lastOpenedEraRowItem } = ERAData;
        /**
         * if newclaimAdded is false then call firstApi
         * if newcalimAdded is true then call second api for manually added claim
         */

        let result;
        let responseData;
        if (!newClaimAdded) {
            let qry = 'header_details_pk=' + lastOpenedEraRowItem + "&claim_id=" + JSON.stringify([claim_pk]);
            result = await service.GetClaimData(qry);
            responseData = result.data;
        } else {
            let query = '?claim_id=' + claim_pk;
            if (isApplied) query += '&is_applied=true'
            result = await service.GetProcedureDataForManuallyAdded(query);
            responseData = result.data.procedure_list;
        }

        if(responseData){

        return { result: responseData, is_applied: is_applied, claim_pk: claim_pk, newClaimAdded: newClaimAdded,ele:ele }
        }else{
            return rejectWithValue("Something went wrong.Please try again")
        }
    }
)



export const getClaimStatusSubStatus = createAsyncThunk(
    "era_payer/claim_status",
    async (payload, thunkAPI) => {
        const pageSize = DEFAULT_PAGING_SIZE;
        const page = 0;
        const practicePK = getStorage('practice');
        const promises = [
            service.ListClaimStatus(pageSize, page, practicePK, null).then(response => response.data),
            service.ListClaimStatusSubStatus(pageSize, page, practicePK).then(response => response.data)
        ]

        try {
            const [
                claimStatusList,
                claimSubStatusList
            ] = await Promise.all(promises);

            return {
                claimStatusList,
                claimSubStatusList
            };

        } catch (error) {
            return thunkAPI.rejectWithValue({ errorMessage: i18n.t("errorMessages.error_drowdown_list_data") })
        }
    }
)


export const getAdjustmentCode = createAsyncThunk(
    "erapayer/adjustment_code_list",
    async (payload) => {
        let { query, name } = payload
        const result = await service.GetListAdjustmentReasonCode(0, 0, query, 'auto');
        return { result: result.data, name: name };
    }
)


export const getClaimListForDropDown = createAsyncThunk(
    "erapayer/claim_for_drop_down",
    async (payload) => {
        let { query, name } = payload
        const result = await service.ClaimsDropdownForERAManualAdd(query, getStorage('practice'));
        return { result: result.data, name: name };
    }
)


export const getClaimDetailsOnSelect = createAsyncThunk(
    "era/claim-on-select",
    async (payload, { rejectWithValue }) => {
        const isItemSelected = payload.length;
        const claimHasNoProcedure = payload.some(obj => obj.name.includes("(None)")); // if claim has no procedure throwing error
        if (claimHasNoProcedure || isItemSelected === 0) { // handle error when evoked the function on backspace key press
            return rejectWithValue(i18n.t("errorMessages.claim_has_no_procedure"));
        }
        let query = payload[0].name.match(/\d+/g)[0]
        const result = await service.GetClaimDataForEraManualAdd(query, getStorage('practice'));
        if(result){
        return result.data.results;
        }
        else{
            return rejectWithValue("Something went wrong.Please try again")
        }
    }
)


export const addSelectedClaimToERAManually = createAsyncThunk(
    "era/claim-on-add",
    async (payload, { getState, dispatch, rejectWithValue }) => {
        try {
            const { ERAData } = getState();
            let { claimDataForEraManualAdd, lastOpenedEraRowItem } = ERAData

            const data = {
                claim_id: claimDataForEraManualAdd.claim_id,
                practice_pk: getStorage('practice'),
                header_pk: lastOpenedEraRowItem
            };

            const response = await service.addClaimToEraManually(data);

            if (response?.data?.status_code === 400) {
                return rejectWithValue(response?.data?.message || i18n.t("errorMessages.add_claim_error"))
            }

            if (response.data?.code === 200) {
                dispatch(reviewClaimData({ claim_pk: response.data?.claim_data?.claim_pk, newClaimAdded: true, is_applied: false }))
                return response.data?.claim_data?.claim_pk;

            } else {
                return rejectWithValue(i18n.t("errorMessages.add_claim_error"))
            }

        } catch (error) {
            return rejectWithValue(i18n.t("errorMessages.add_claim_error"))
        }
    }
)


export const SaveEraDetails = createAsyncThunk(
    "era/save_era_details",
    async (_, { getState, rejectWithValue }) => {
        const { ERAData } = getState();
        const { eraEditModalData, lastOpenedEraRowItem } = ERAData;

        const { era_received_date, payment_date } = eraEditModalData || {};

        if (!era_received_date) {
            return rejectWithValue("Invalid Production Date");
        }

        if (!payment_date) {
            return rejectWithValue("Invalid Payment Date");
        }

        try {
            const payload = {
                ...eraEditModalData,
                era_received_date: formatDateUS(era_received_date),
                payment_date: formatDateUS(payment_date),
            };
            const result = await service.UpdateERA(lastOpenedEraRowItem, payload);

            if (result?.status === 200) {
                return result;
            }

            return rejectWithValue(i18n.t("errorMessages.failed_common_error"));
        } catch (error) {
            return rejectWithValue(i18n.t("errorMessages.commonError"));
        }
    }
);


export const MarkAsReviewed = createAsyncThunk(
    "era/mark_as_reviewed",
    async (_, { getState, rejectWithValue }) => {
        try {
            const { ERAData } = getState();
            const { reviewData, lastOpenedEraRowItem } = ERAData;

            const claimIds = getSelectedClaimIDs(reviewData);
            const totalClaims = Object.keys(reviewData).length;
            const reviewedClaims = getReviewedClaims(reviewData);

            if (claimIds.length === 0) {
                const message =
                    reviewedClaims.length === totalClaims
                        ? i18n.t("payments.eraPage.all_claim_already_reviewed")
                        : i18n.t("payments.eraPage.select_to_reviewed")
                return rejectWithValue(message);
            }

            const result = await service.MakeAsReviewed(lastOpenedEraRowItem, { claimids: claimIds });

            if (result.status === 200) {
                const query = `header_details_pk=${lastOpenedEraRowItem}`;
                const claimResult = await service.GetClaimDataSummary(query);
                return claimResult.data;
            }

            const errorMessages = {
                400: i18n.t("payments.eraPage.no_claim_id_provided"),
                404: i18n.t("errorMessages.commonError")
            };

            return rejectWithValue(errorMessages[result.status] || i18n.t("errorMessages.Un_expected_error"));
        } catch {
            return rejectWithValue(i18n.t("errorMessages.commonError"));
        }
    }
);


export const onDeleteClaimAction = createAsyncThunk(
    "era/delete_claim_action",
    async (_, { getState, rejectWithValue }) => {
        try {
            let { ERAData } = getState();
            let { deleteModal } = ERAData;
            let result = await service.RemoveEraFromList(deleteModal.claim_pk);
            if (result.status === 200) {
                return { id: deleteModal.element };
            } else {
                return rejectWithValue(i18n.t("payments.eraPage.error_delete_era"));
            }
        } catch (error) {
            return rejectWithValue(i18n.t("errorMessages.commonError"));
        }
    })


export const eraProcedureDataSave = createAsyncThunk(
    "era/era_procedure_data_save",
    async (_, { getState, rejectWithValue,dispatch }) => {
        try {
            const { ERAData } = getState();
            const {
                procedureData,
                duplicateProcedureData,
                procedureError,
                isNewClaimAdded,
                selectedPaymentPK,
                lastOpenedEraRowItem,
                saveWithOverRide,
            } = ERAData;

            const practicePK = getStorage("practice");
            const over_ride_status = !!saveWithOverRide;
            const formatedData = await getChangedProcedure(duplicateProcedureData, procedureData,isNewClaimAdded);
            const targetData = isNewClaimAdded ? procedureData : formatedData;
            const {status,message} = await checkForMandatoryFields(targetData);
            if (status) {
                return rejectWithValue({ message:message, type: "msg" });
            }
            const hasWarnings = await checkForWaringErrors(procedureError);
            if (hasWarnings && !over_ride_status) {
                return rejectWithValue({ message: "", type: "waring" });
            }
            if (isNewClaimAdded && Object.keys(formatedData).length === 0) {
                return rejectWithValue({ message: "", type: "confirmation" });
            }

            if (!isNewClaimAdded && Object.keys(formatedData).length === 0) {
                dispatch(MarkAsReviewedOnSave())
                return rejectWithValue({ message:i18n.t("payments.eraPage.no_data_to_save"), type: "info",close:true });
            }
            const procedure_data = await structureSaveProcedureData(targetData);
            const payload = {
                header_pk: lastOpenedEraRowItem,
                procedures: procedure_data,
                practice_pk: practicePK,
            };
            const result = await service.EraModalSave(selectedPaymentPK, payload);
            if (result.status === 200) {
                return {
                    result_data: result.data,
                    is_new_claim_id: isNewClaimAdded,
                    lastOpenedEraRowItem,
                    over_ride_status,
                };
            }

            if (result.status === 400 && result.error_message === "invalid_paid_by_entity") {
                return rejectWithValue({ message: i18n.t("payments.eraPage.valid_paid_by_entity_error"), type: "msg" });
            }

            return rejectWithValue({ message: i18n.t("errorMessages.commonError"), type: "msg" });

        } catch (error) {
            return rejectWithValue({ message: i18n.t("errorMessages.commonError"), type: "msg" });
        }
    }
);

export const MarkAsReviewedOnSave = createAsyncThunk(
    "era/mark_as_reviewed_on_save",
    async (_, { getState, rejectWithValue }) => {
        try {
            const { ERAData } = getState();
            const { reviewData, lastOpenedEraRowItem,lastOpenedClaimRowItem } = ERAData;

            const claimIds = getSelectedClaimIDs(reviewData);

            if (claimIds.length === 0) {
                return lastOpenedClaimRowItem;
            }

            const result = await service.MakeAsReviewed(lastOpenedEraRowItem, { claimids: claimIds });

            if (result.status === 200) {
                return lastOpenedClaimRowItem;
            }
        } catch {
            return rejectWithValue(i18n.t("errorMessages.commonError"));
        }
    }
);


export const onApplyPayment = createAsyncThunk(
    "era/on_apply_payment",
    async (_, { getState, rejectWithValue,dispatch }) => {
        try {
            const { ERAData } = getState();
            const { insurancePaymentVariables, lastOpenedEraRowItem,pagination,reviewData } = ERAData;
            const header_pk = String(lastOpenedEraRowItem);
            const practice_pk = getStorage("practice");
            const reference_check_number = insurancePaymentVariables?.reference_check_number ?? "";

            const allReviewed = Object.values(reviewData).every(item => item.is_reviewed === true);

            if (!allReviewed) {
                return rejectWithValue(i18n.t("payments.eraPage.make_as_reviewed_error"));
            }

            const response = await service.SaveInsurancePaymentProceduresFromERAPosting({
                header_pk,
                practice_pk,
                reference_check_number,
            });

            const { data, status } = response;
            const message = data?.message;
            const msg = data?.msg || data?.error_message;

            if (data?.code === 200 && msg === "success") {
                dispatch(getERAlist({ page: pagination.activePage, calledFrom: "search", practice: practice_pk }));
                return data;
            }

            const errorMap = {
                transaction_set_not_found: i18n.t("errorMessages.not_find_error"),
                reference_check_number_unique: i18n.t("errorMessages.checkNumberExist"),
                transaction_applied: i18n.t("errorMessages.era_applied"),
                provider_failed: i18n.t("errorMessages.already_exist_era"),
                header_details_exists: i18n.t("errorMessages.already_exist_era"),
                procedure_not_found: i18n.t("errorMessages.not_match_claim_procedure"),
                claim_not_found: i18n.t("errorMessages.not_match_claim_procedure"),
                not_found: i18n.t("errorMessages.not_match_claim_procedure"),
                era_payer_not_found: i18n.t("errorMessages.mismatch_payer"),
                payer_not_found: i18n.t("errorMessages.mismatch_payer"),
                ValidationError: i18n.t("errorMessages.input_validation"),
            };

            if (message === "invalid_responsibility_type") {
                return rejectWithValue(`Claim status selected not matching with the Priority on Procedure ${data?.data?.cpt ?? ""}`);
            }

            if (message === "cpt_or_claim_status_missing") {
                return rejectWithValue(i18n.t("payments.post_payments.insurancePayment.procedureOrClaimStatusMissing"));
            }

            if (status === 409) {
                return rejectWithValue(i18n.t("payments.eraPage.duplicateReference"));
            }

            const key = message || msg || data?.error_exception;
            return rejectWithValue(errorMap[key] || i18n.t("errorMessages.auto_posting_era"));

        } catch {
            return rejectWithValue(i18n.t("errorMessages.commonError"));
        }
    }
);


export const onAllERAListExport = createAsyncThunk(
    "era/era_list_export",
    async (_, { getState, rejectWithValue,dispatch }) => {
    try{
        const { ERAData } = getState();
        const { selectedEraList } = ERAData;
        const result = await service.ExportERAList({ 'header_details_pks': selectedEraList });
        if(result.status==200){
            dispatch(onGridCheckBoxClickEraList({selected:false,id:"",clickedFrom:'headers'}))
            return {status:result.status,data:result.data,header:result.headers}
        }else{
            return rejectWithValue(i18n.t("payments.eraPage.wrong_era_exporting"));
        }
    }catch(error){
        return rejectWithValue(i18n.t("payments.eraPage.wrong_era_exporting"));
    }
});


export const onExportFiles = createAsyncThunk(
    "era/on_export_files",
    async (payload, { getState, rejectWithValue }) => {
        try {
            const { exportType, exportLabel, id } = payload;
            const { ERAData } = getState();
            const practiceId = getStorage("practice");

            const { selectedColumns, selectedPK } = ERAData.xlsExportKey;
            const selectedId = exportType === "xls" ? selectedPK : id;

            // XLS Export
            if (exportType === "xls") {
                const fields = JSON.stringify(selectedColumns);
                const query = `?export_type=xls&payment_header_pk=${selectedId}&fields=${fields}`;
                const result = await service.GetERAPaymentExport(query);
                if (result?.data) {
                    return { data: result.data, header: result.headers, type: "xls" };
                }
            }

            // PDF Export
            if (exportType === "pdf") {
                const query = `?export_type=pdf&payment_header_pk=${selectedId}`;
                const result = await service.exportERAPDF(query);
                if (result?.data) {
                    return { data: result.data, header: result.headers, type: "pdf" };
                }
            }

            // Download ERA File
            if (exportLabel === "Download ERA") {
                const result = await service.GetPresignedEraURL({
                    era_id: id,
                    practice_id: practiceId,
                });
                if (result?.data) {
                    return { data: result.data, header: result.headers, type: "era_file" };
                }
            }

            // Fallback
            return rejectWithValue(i18n.t("payments.eraPage.wrong_era_exporting"));

        } catch (error) {
            return rejectWithValue(i18n.t("payments.eraPage.wrong_era_exporting"));
        }
    }
);







